import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CurrencyContext = createContext({
  currencySymbol: '₦',
  currencyName: 'Nigerian Naira',
  currencyCode: 'NGN',
  loading: true,
  formatCurrency: (amount) => `₦${amount.toFixed(2)}`
});

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState({
    currencySymbol: '₦',
    currencyName: 'Nigerian Naira',
    currencyCode: 'NGN'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrency();
  }, []);

  const fetchCurrency = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }
      
      const response = await axios.get(`${API}/settings/currency`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setCurrency({
        currencySymbol: response.data.currency_symbol || '₦',
        currencyName: response.data.currency_name || 'Nigerian Naira',
        currencyCode: response.data.currency_code || 'NGN'
      });
    } catch (error) {
      // Use default currency on error
      console.error('Failed to fetch currency settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    const num = typeof amount === 'number' ? amount : parseFloat(amount) || 0;
    return `${currency.currencySymbol}${num.toFixed(2)}`;
  };

  return (
    <CurrencyContext.Provider value={{ ...currency, loading, formatCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export default CurrencyContext;
